

















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Consultant as ConsultantProps } from '@/types/consultants'

@Component
export default class Consultant extends Vue {
  @Prop() readonly consultant!: ConsultantProps

  get imageUrl(): string {
    return `/images/consultants/${ this.consultant.image }`
  }
}
